module.exports = __webpack_public_path__ + "static/media/Call_Patient.5ab10008.svg";